import React from 'react';
import { IBaseSection, IContent } from 'src/interface';
import { ContentTopicType1Section } from './type1';
import { ContentTopicType2Section } from './type2';
import { ContentTopicType3Section } from './type3';
import { ContentTopicType4Section } from './type4';

type TOPIC_TYPE = 'type_1' | 'type_2' | 'type_3' | 'type_4';

const TOPIC_TYPE = {
    TYPE_1: 'type_1' as TOPIC_TYPE,
    TYPE_2: 'type_2' as TOPIC_TYPE,
    TYPE_3: 'type_3' as TOPIC_TYPE,
    TYPE_4: 'type_4' as TOPIC_TYPE,
};


interface IProps extends IBaseSection<IContent> {
    type?: TOPIC_TYPE;
}

const TOPIC_MAP = {
    [TOPIC_TYPE.TYPE_1]: ContentTopicType1Section,
    [TOPIC_TYPE.TYPE_2]: ContentTopicType2Section,
    [TOPIC_TYPE.TYPE_3]: ContentTopicType3Section,
    [TOPIC_TYPE.TYPE_4]: ContentTopicType4Section,
};

export function ContentTopicHomeSection(props: IProps) {
    const { type = TOPIC_TYPE.TYPE_1, id } = props;
    const renderItem = () => {
        const Component = TOPIC_MAP[type || TOPIC_TYPE.TYPE_1];
        if (!Component) {
            return null;
        }

        return <Component key={`content.type.${id}`} {...props} />;
    };

    return <>{renderItem()}</>;
}

export default React.memo(ContentTopicHomeSection);
